import { Tooltip } from "@mui/material";
import Copyright from "@mui/icons-material/Copyright";
import AppStateContext from "contexts/AppStateContext";
import { FunctionComponent, useContext } from "react";

type Props = {
  active: boolean;
  showLabel?: boolean;
};

const MaterialCertificateIcon: FunctionComponent<Props> = ({
  active,
  showLabel = false,
}) => {
  const { strings } = useContext(AppStateContext);
  return (
    <Tooltip title={strings.MaterialCertificate}>
      <span style={{ display: "inline-flex", alignItems: "center", gap: "0.2rem" }}>
        <Copyright
          sx={{
            fontSize: "1.4em",
            verticalAlign: "middle",
            color: active ? "inherit" : "lightgrey",
          }}
        />
        {showLabel && active && (
          <span style={{ fontSize: "0.85em" }}>{strings.MaterialCertificate}</span>
        )}
      </span>
    </Tooltip>
  );
};

export default MaterialCertificateIcon;
